import { render, staticRenderFns } from "./LoginIdentity.vue?vue&type=template&id=658a1c71&scoped=true&"
import script from "./LoginIdentity.vue?vue&type=script&lang=js&"
export * from "./LoginIdentity.vue?vue&type=script&lang=js&"
import style0 from "./LoginIdentity.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./LoginIdentity.vue?vue&type=style&index=1&id=658a1c71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658a1c71",
  null
  
)

export default component.exports